import { ErrorOutline } from '@mui/icons-material';

import { IStatusProps } from 'v3/shared/components/Status/types';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { Container } from './styles';

export const Status: React.FC<IStatusProps> = ({ title }) => {
  return (
    <Container>
      <SubtitleMedium>{title}</SubtitleMedium>
      <ErrorOutline className="pointer" />
    </Container>
  );
};
